import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FAQCategory } from '../../interfaces/FAQ';
import styles from './FAQ.module.scss';
import { FAQItemComponent } from './FAQItem';

interface FAQSectionProps {
  searchTexts: string[];
  section: FAQCategory;
}

export const FAQSection: FC<FAQSectionProps> = ({ section, searchTexts }) => {
  const { t } = useTranslation();
  const translatedCategory = t(`faqCategories:${section.category}`, { defaultValue: section.category });
  const { articles: faqs } = section;

  const hideTitle = searchTexts.length > 0;

  return (
    <div>
      {!hideTitle && <h2 className={styles.faqSectionTitle}>{translatedCategory}</h2>}

      <div>
        {faqs.map((faq) => (
          <FAQItemComponent faq={faq} key={faq.title} searchTexts={searchTexts} />
        ))}
      </div>
    </div>
  );
};
